import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
// Self-hosted IBM Plex fonts (#766): unmodified IBM split woff2 files for Plex Sans 400/500/600/700
// and Plex Mono 400, replacing the former render-blocking third-party font-host @import.
import './assets/fonts/ibm-plex/ibm-plex.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import AppRouter from './components/Router/Router'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { AuthProvider } from './context/AuthContext'
import { NotificationProvider } from './context/NotificationContext'
import { UserProvider } from './context/UserContext'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
	<Provider store={store}>
		<AuthProvider>
			<BrowserRouter>
				<NotificationProvider>
					<UserProvider>
						<AppRouter />
					</UserProvider>
				</NotificationProvider>
			</BrowserRouter>
		</AuthProvider>
	</Provider>
)
